import curry from 'just-curry-it';
import createAction from './createAction';
export default (function (type, payloadCreator) {
  return curry(createAction(type, payloadCreator), payloadCreator.length);
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/createCurriedAction.js
// module id = 1442
// module chunks = 1